import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import _ from "lodash";

const getItems = () => [
  { key: "Relevance", value: "Relevance" },
  { key: "Read/Unread", value: "Read/Unread" },
  { key: "Last updated", value: "Last updated" },
  { key: "Page created", value: "Page created" },
  { key: "Title", value: "Title" },
];

// a little function to help us with reordering the result
const reorder = (
  list: { key: string; value: string }[],
  startIndex: number,
  endIndex: number
): { key: string; value: string }[] => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 8;

const getItemStyle = (isDragging: boolean, draggableStyle: CSSStyleRule) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: 0,
  margin: `0 0 ${grid}px 0`,
  display: "flex",
  alignItems: "center",

  // change background colour if dragging
  // background: isDragging ? "lightgreen" : "inherit",

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = () => ({
  background: "#EFF2F7",
});

function SelectDateTimeModal(props) {
  const {sort, order, updateFilter} = props;
  const [items, setItems] = useState<{ key: string; value: string }[]>(
    getItems()
  );
  // const [selected, setSelected] = useState<string>("");
  // const [order, setOrder] = useState<string>("ASC");

  const onDragEnd = (result: any) => {
    if (!result.destination) {
      return;
    }
    const newItems = reorder(
      items,
      result.source.index,
      result.destination.index
    );
    setItems(newItems);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided: any) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={getListStyle()}
          >
            {items.map((item, index) => (
              <Draggable key={item.key} draggableId={item.key} index={index}>
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={getItemStyle(
                      snapshot.isDragging,
                      provided.draggableProps.style
                    )}
                    onClick={()=>{
                      if(item.value === sort){
                        updateFilter('order', order === 'ASC' ? 'DESC': 'ASC')
                      }
                      else{
                        updateFilter('order', 'ASC')
                        updateFilter('sort', item.value)
                      }
                    }}
                  >
                    <img src="/images/move.png" className={`mr-3 ${(order === 'DESC' && sort === item.value) ? 'transform-flip': ''}`} />
                    <h5 className={`${sort === item.value ? 'sort-selected': ''}`}>{item.value}</h5>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}

export default SelectDateTimeModal;
